export const placeLoader = {
    width: 200,
    height: 100,
    borderRadius: 5,
    marginRight: 20,
};
